import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Screenshot from "@ltypes/screenshot";
import ScreenshotService from "@services/ScreenshotService";
import { sceneTypes } from "../../../constants";
import DateHelper from "@helpers/DateHelper";
import ScreenshotModal from "@components/modals/ScreenshotModal/ScreenshotModal";
import Loader from "@components/ui/Loader/Loader";
import './ScreenshotsPage.scss';

function ScreenshotsPage() {
    const [isLoading, setLoading] = useState<boolean>(true);
    const [screenshots, setScreenshots] = useState<Array<Screenshot>>([]);
    const [currentScreenshot, setCurrentScreenshot] = useState<Screenshot|null>(null);
    const [isModalVisible, setModalVisible] = useState<boolean>(false);

    const { t } = useTranslation();

    const service = new ScreenshotService;

    const openScreenshot = (screenshot: Screenshot) => {
        setCurrentScreenshot(screenshot);
        setModalVisible(true);
    };

    useEffect(() => {
        setLoading(true);
        const promise = service.search(null, null);
        
        promise.then((data: any) => {
            setScreenshots(data.body);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    return (
        <div className="p-3">
            <h1>{t('title.screenshots')}</h1>

            {isLoading ? (
                <div className="text-center">
                    <Loader size="4rem" noMargin/>
                </div>
            ) : (
                <>
                    {screenshots.length === 0 && (
                        <h3 className="text-center">{t('page.screenshots.no_screenshot')}</h3>
                    )}
                    <div className="screenshot-container">
                        {screenshots.map((screenshot: Screenshot) => (
                            <div key={screenshot.id} className="screenshot-item" onClick={() => openScreenshot(screenshot)}>
                                <div className="screenshot-item-image" style={{backgroundImage: `url("${process.env.REACT_APP_API_URL}/media/screenshots/${screenshot.id}.jpg")`}}></div>
                                <span className="screenshot-item-label">{t(`page.scenes.type.${sceneTypes[screenshot.scene_type]}`)}</span>
                                <span className="screenshot-item-date">{DateHelper.formatDate(screenshot.created_at)}</span>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <ScreenshotModal screenshot={currentScreenshot} visible={isModalVisible} onHide={() => {
                setModalVisible(false);
                setCurrentScreenshot(null);
            }}/>
        </div>
    );
}

export default ScreenshotsPage;
